import type React from 'react';
import { Box } from '@vp/swan';

const baseStyles: React.CSSProperties = {
    position: 'relative',
    overflow: 'hidden',
    backgroundRepeat: 'no-repeat',
    backgroundSize: `
                    contain
                    , 1029px 666px
                    , 1029px 666px 
                    , 804px 520px
                    , cover
                `,
};

const heroStyles: React.CSSProperties = {
    ...baseStyles,
    backgroundImage: `
                    url(https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/hero-stars.webp)
                    , url(https://cms.cloudinary.vpsvc.com/image/upload/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/Clouds_1.webp)
                    , url(https://cms.cloudinary.vpsvc.com/image/upload/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/Clouds_1.webp)
                    , url(https://cms.cloudinary.vpsvc.com/image/upload/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/Clouds_1.webp)
                    , linear-gradient(180deg, #6FD0F5 27.81%, #F6F6EC 129.01%)
                `,
    backgroundPosition: `
                    center
                    ,left -70px top -400px
                    , right -325px top -105px
                    , left -50px bottom -240px
                    , center
                `,
};

const logoToLifeStyles: React.CSSProperties = {
    ...baseStyles,
    backgroundImage: `
                    url(https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/Stars.webp)
                    , url(https://cms.cloudinary.vpsvc.com/image/upload/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/Clouds_1.webp)
                    , url(https://cms.cloudinary.vpsvc.com/image/upload/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/Clouds_1.webp)
                    , url(https://cms.cloudinary.vpsvc.com/image/upload/vista-logos-pages/en-US/logomaker-gen-ai/logo-to-life/Clouds_1.webp)
                    , linear-gradient(180deg, #6FD0F5 27.81%, #F6F6EC 129.01%)
                `,
    backgroundPosition: `
                    center
                    ,left -685px top -250px
                    , right -383px bottom -260px
                    , left -140px bottom -385px
                    , center
                `,
};

const BoxWithCloudBackground = ({
    variation,
    children,
}: {
    variation: 'hero' | 'logo-to-life';
    children: React.ReactNode;
}) => {
    return <Box style={variation === 'hero' ? heroStyles : logoToLifeStyles}>{children}</Box>;
};

export default BoxWithCloudBackground;
